import React from 'react';
import gpt3Logo from '../../assets/logo.svg';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">Step into the future.</h1>
    </div>

    <div className="gpt3__footer-btn">
      <p>Request Access</p>
    </div>

    <div className="gpt3__footer-links">
      <div className="gpt3__footer-links_logo">
        <img src={gpt3Logo} alt="gpt3_logo" />
        <p>OpenAI 
        <br /> 
        All Rights Reserved
        </p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Links</h4>
        <p>About</p>
        <p>Docs</p>
        <p>Social Media</p>    
        <p>Careers</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p>Terms & Conditions</p>
        <p>Privacy Policy</p>
        <p>Contact</p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p>6345 6th Ave S. Seattle, WA 98108</p>
        <p>+18082277864</p>
        <p>dev@gpt3.com</p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>©2021 WCC. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;